import React from 'react';
interface KpiCardProps {
  title: string;
  value: string | number;
  icon: ReactNode;
  trend?: {
    value: string | number;
    isPositive: boolean;
  };
  color?: string;
}
export function KpiCard({
  title,
  value,
  icon,
  trend,
  color = 'blue'
}: KpiCardProps) {
  const colorClasses = {
    blue: 'bg-blue-50 text-blue-600',
    green: 'bg-green-50 text-green-600',
    purple: 'bg-purple-50 text-purple-600',
    orange: 'bg-[var(--brand-primarysubtle)] text-[var(--brand-primarytextonwhite)]'
  };
  const iconClass = colorClasses[color as keyof typeof colorClasses] || colorClasses.blue;
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4" data-id="element-1996">
      <div className="flex items-start" data-id="element-1997">
        <div className={`p-2 rounded-lg ${iconClass} mr-3 flex-shrink-0`} data-id="element-1998">
          {icon}
        </div>
        <div className="min-w-0" data-id="element-1999">
          <h3 className="text-xs font-medium text-gray-500 truncate" data-id="element-2000">
            {title}
          </h3>
          <div className="flex items-end flex-wrap" data-id="element-2001">
            <p className="text-lg font-semibold text-gray-800 mt-1 mr-1" data-id="element-2002">
              {value}
            </p>
            {trend && <span className={`text-xs ${trend.isPositive ? 'text-green-600' : 'text-red-500'}`} data-id="element-2003">
                {trend.isPositive ? '↑' : '↓'} {trend.value}
              </span>}
          </div>
        </div>
      </div>
    </div>;
}